import { z } from "zod";

// Skema untuk satu baris data di dalam tabel
const ReservationTableRowSchemaV4 = z.object({
    name: z.string(),
    nb_reservations: z.number(),
    nb_nights: z.coerce.string(),
    avg_length_of_stay: z.coerce.string(),
    total_earning: z.coerce.string(),
    avg_earning: z.coerce.string(),
    percentage: z.coerce.string(),
});

// Skema untuk baris total di bagian bawah
const ReservationTableTotalSchemaV4 = z.object({
    nb_reservations: z.number(),
    nb_nights: z.number(),
    avg_length_of_stay: z.coerce.string(),
    total_earning: z.coerce.string(),
    avg_earning: z.coerce.string(),
    percentage: z.number(),
});

// Skema untuk keseluruhan response API
const ReservationTableResponseV4 = z.object({
    success: z.boolean(),
    message: z.string(),
    code: z.number(),
    data: z.array(ReservationTableRowSchemaV4),
    total: ReservationTableTotalSchemaV4,
});

// Ekspor tipe data yang di-infer dari skema
export type ReservationTableDataType = z.infer<typeof ReservationTableResponseV4>;

export { ReservationTableResponseV4 };